<script lang="ts">
  import { cn } from "$lib/utils/cn";

  interface Props {
    value?: string;
    placeholder?: string;
    rows?: number;
    disabled?: boolean;
    class?: string;
    oninput?: (e: Event) => void;
  }

  let {
    value = $bindable(""),
    placeholder,
    rows = 3,
    disabled = false,
    class: className,
    oninput,
    ...restProps
  }: Props = $props();
</script>

<textarea
  bind:value
  {placeholder}
  {rows}
  {disabled}
  {oninput}
  class={cn(
    "w-full px-3 py-2 text-sm",
    "bg-surface-3 border border-border-default rounded",
    "text-text-primary placeholder:text-text-muted",
    "focus:outline-none focus:border-accent-primary focus:ring-1 focus:ring-accent-primary/20",
    "disabled:opacity-50 disabled:cursor-not-allowed",
    "resize-none transition-colors",
    className
  )}
  {...restProps}
></textarea>
